var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "public"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10990_10696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.12207,
    y: 0.465088,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10990_10696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "public_2",
    d: "M8.12325 14.7985C7.2473 14.7985 6.42394 14.6322 5.65318 14.2998C4.88242 13.9674 4.21196 13.5162 3.64182 12.9463C3.07166 12.3764 2.62029 11.7062 2.2877 10.9358C1.95511 10.1654 1.78882 9.34223 1.78882 8.46627C1.78882 7.59031 1.95504 6.76696 2.28749 5.9962C2.61993 5.22544 3.0711 4.55498 3.64099 3.98484C4.21089 3.41468 4.88105 2.96331 5.65147 2.63072C6.42188 2.29813 7.24506 2.13184 8.12102 2.13184C8.99697 2.13184 9.82033 2.29806 10.5911 2.6305C11.3619 2.96295 12.0323 3.41411 12.6025 3.984C13.1726 4.5539 13.624 5.22406 13.9566 5.99449C14.2892 6.7649 14.4555 7.58808 14.4555 8.46404C14.4555 9.33999 14.2892 10.1633 13.9568 10.9341C13.6243 11.7049 13.1732 12.3753 12.6033 12.9455C12.0334 13.5156 11.3632 13.967 10.5928 14.2996C9.82239 14.6322 8.99921 14.7985 8.12325 14.7985ZM7.45547 13.7652V12.4652C7.0888 12.4652 6.77491 12.3346 6.5138 12.0735C6.25269 11.8124 6.12213 11.4985 6.12213 11.1318V10.4652L2.92213 7.26515C2.8888 7.46515 2.85825 7.66515 2.83047 7.86515C2.80269 8.06515 2.7888 8.26515 2.7888 8.46515C2.7888 9.8096 3.23047 10.9874 4.1138 11.9985C4.99714 13.0096 6.11102 13.5985 7.45547 13.7652ZM12.0555 12.0652C12.2777 11.8207 12.4777 11.5568 12.6555 11.2735C12.8332 10.9902 12.9805 10.6957 13.0971 10.3902C13.2138 10.0846 13.3027 9.77071 13.3638 9.44849C13.4249 9.12626 13.4555 8.79849 13.4555 8.46515C13.4555 7.37304 13.1538 6.37565 12.5503 5.47299C11.9469 4.57033 11.1375 3.919 10.1221 3.519V3.79849C10.1221 4.16515 9.99158 4.47904 9.73047 4.74015C9.46936 5.00126 9.15547 5.13182 8.7888 5.13182H7.45547V6.46515C7.45547 6.65404 7.39158 6.81238 7.2638 6.94015C7.13602 7.06793 6.97769 7.13182 6.7888 7.13182H5.45547V8.46515H9.45547C9.64436 8.46515 9.80269 8.52904 9.93047 8.65682C10.0582 8.7846 10.1221 8.94293 10.1221 9.13182V11.1318H10.7888C11.0777 11.1318 11.3388 11.2179 11.5721 11.3902C11.8055 11.5624 11.9666 11.7874 12.0555 12.0652Z",
    fill: "#5F6368"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/websiteIcon.99b8eaee26bafd5ece73cf87840c5982.svg";
export { ForwardRef as ReactComponent };